/*
 * PagesGradientBg — infinite background color animation for specific pages.
 *
 * Dependencies:
 *   - snippet: api-pages-gradient-bg.liquid
 *   - metafield: shop.metafields.custom.settings_bg_gradient_for_pages (JSON)
 *
 * Usage:
 *   {% render 'api-pages-gradient-bg' %}
 *
 * Metafield JSON format:
 *   {
 *     "enable_everywhere": true / false   //use gradient everywhere
 *     "animation_delay": 3,              // seconds per color transition (default: 1)
 *     "hex_gradient_color": ["#fff", "#ffe9fb", "#cbebfa"],  // color sequence
 *     "pages_url": ["/collections/"]     // URL prefixes to enable
 *   }
 */

class PagesGradientBg {
  constructor(selector) {
    this.targetElement = document.querySelector(selector);
    this.currentPage = window.location.pathname

    if (!this.data || !this.targetElement) return;
    if (!this.isAllowedPage()) return;

    this.init();
  }

  get data() {
    const dataContainer = document.querySelector("[id='data-bg-gradient-for-pages']");
    if (!dataContainer) return null;

    const dataStr = dataContainer.textContent.trim();
    if (dataStr == 'null') return null

    return JSON.parse(dataStr)
  }

  get keyframes() {
    const {hex_gradient_color} = this.data;
    if (!hex_gradient_color) return

    return  [...hex_gradient_color, hex_gradient_color[0]].map((color) => ({ backgroundColor: color }))
  }

  isAllowedPage() {
    const { enable_everywhere, pages_url } = this.data;
    if (enable_everywhere) return true;

    const normalize = (url) => '/' + url.replace(/^\/|\/$/g, '');
    const current = normalize(this.currentPage);

    return pages_url.some(url => {
      const normalizedUrl = normalize(url);

      if (normalizedUrl === '/') return current === '/';

      return current.startsWith(normalizedUrl);
    });
  }

  initGradientAnimate() {
    let {animation_delay, hex_gradient_color} = this.data;
    if (!hex_gradient_color) return

    if (!animation_delay) {
      animation_delay = 1;
    }

    document.querySelector('body').classList.add('enable-gradient-bg');

    this.targetElement?.animate(this.keyframes, {
      duration: hex_gradient_color.length * (animation_delay * 1000),
      easing: "linear",
      iterations: Infinity,
    });
  }

  init() {
    this.initGradientAnimate();
  }
}

new PagesGradientBg('body');